import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import {get} from 'lodash';
import truncateHtml from '../../utils/truncateHtml';
import CardPublishDate from '../common/card_publish_date';
import { SOLD_CONTENT_TYPES } from '../../constants';

const AUTHOR_MAX_LENGTH = 20;

const paidContentLabel = () => (
  <div className="section">
    <RosettaFormattedMessage parentFilename={__filename}
      id="paid_content_label"
      description="Label that appears on paid content prime cards"
      defaultMessage="Paid Content"
    />
  </div>
);

const contentCategoryLabel = (__html) =>
  <div className="section" dangerouslySetInnerHTML={{ __html }} />;

export default class PrimeCardElements extends Component {
  shouldComponentUpdate = (nextProps) =>
    this.props.cardID !== nextProps.cardID;

  author = () => {
    const authorName = truncateHtml(
      get(this.props, 'contributors[0].display_name'),
      { length: AUTHOR_MAX_LENGTH, omission: '...' }
    );

    return (
      <div className="author">
        <span className="author-name"
          dangerouslySetInnerHTML={{ __html: authorName }}
        />
      </div>
    );
  };

  label = () =>
    this.props.meta.sold_content_type === SOLD_CONTENT_TYPES.CUSTOM
      ? paidContentLabel()
      : contentCategoryLabel(this.props.label);

  render() {
    const { truncated_title_80, published, timeZone } = this.props;

    return (
      <div className="story-content">
        {this.props.isVideoCard && <figure className="type icon-video" />}
        {this.label()}
        <div className="title">
          <span dangerouslySetInnerHTML={{ __html: truncated_title_80 }} />
        </div>
        <div className="story-meta">
          {this.author()}
          <div className="publish-date">
            <CardPublishDate timestamp={published} timeZone={timeZone} />
          </div>
        </div>
      </div>
    );
  }
}

PrimeCardElements.propTypes = {
  cardID: PropTypes.number.isRequired,
  contributors: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string
  })).isRequired,
  excerpt_truncated_155: PropTypes.string.isRequired,
  isVideoCard: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    sold_content_type: PropTypes.string
  }),
  published: PropTypes.number.isRequired,
  truncated_title_80: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  timeZone: PropTypes.string
};

PrimeCardElements.defaultProps = {
  contributors: [{}],
  excerpt_truncated_155: '',
  label: '',
  published: 0,
  truncated_title_80: '',
  type: ''
};
